{{ value.join(', ') }}